import Button from '@/common/components/base/button/Button';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import BodyForm from '@/modules/adjusterReportModules/Insurer-information/components/bodyInsurance/editBodyInsurance/forms/BodyForm';
import PropertyForm from '@/modules/adjusterReportModules/Insurer-information/components/bodyInsurance/editBodyInsurance/forms/PropertyForm';
import useEditBodyInsurance from '@/modules/adjusterReportModules/Insurer-information/components/bodyInsurance/editBodyInsurance/hook/useEditBodyInsurance';
import { FormProvider } from 'react-hook-form';

const EditBodyInsurance = () => {
  const { submitHandler, methods, mutationPending } = useEditBodyInsurance();

  return (
    <FormProvider {...methods}>
      <BodyForm />
      <PropertyForm />
      <Button
        onClick={methods.handleSubmit(submitHandler)}
        type="submit"
        width="100%"
        marginTop="16px"
        marginBottom="24px"
        disabled={
          mutationPending ||
          !methods.formState.isValid ||
          methods.formState.isSubmitting
        }
      >
        ثبت
      </Button>
      <ImagesFabMainModal state="body" />
    </FormProvider>
  );
};

export default EditBodyInsurance;
